<section class="card deletion-operations">
  <div class="header-row">
    <div>
      <h2>Deletion Operations</h2>
      <p>Track local identity and Stripe cleanup attempts. Completed steps are not repeated during retries.</p>
    </div>
    <button pButton type="button" icon="pi pi-refresh" class="p-button-outlined" label="Refresh"
      aria-label="Refresh deletion operations" [loading]="loading" (click)="loadOperations()"></button>
  </div>

  <div class="filters">
    <span class="p-input-icon-left search-field">
      <i class="pi pi-search"></i>
      <input pInputText type="search" placeholder="User, billing, or correlation ID"
        aria-label="Search deletion operations"
        [value]="search" (input)="onSearch($any($event.target).value)" />
    </span>
    <p-dropdown [options]="statusOptions" [(ngModel)]="status" optionLabel="label" optionValue="value"
      ariaLabel="Filter deletion operations by status"
      (onChange)="onStatusChange()"></p-dropdown>
  </div>

  <p-table [value]="operations" [loading]="loading" [lazy]="true" [paginator]="true"
    [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 25, 50]"
    (onPage)="onPage($event)" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th>Requested</th><th>User / Reference</th><th>Status</th><th>Stripe</th><th>Identity</th>
        <th>Attempts</th><th>Next attempt</th><th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-operation>
      <tr>
        <td>{{ operation.requestedAtUtc | date:'medium' }}</td>
        <td>
          <strong>{{ operation.userId }}</strong>
          <small>Operation: {{ operation.operationId }}</small>
          <small *ngIf="operation.billingId">Billing: {{ operation.billingId }}</small>
          <small>Correlation: {{ operation.correlationId }}</small>
        </td>
        <td><p-tag [value]="operation.status" [severity]="statusSeverity(operation.status)"></p-tag></td>
        <td><p-tag [value]="operation.stripe.status" [severity]="statusSeverity(operation.stripe.status)"></p-tag></td>
        <td><p-tag [value]="operation.identity.status" [severity]="statusSeverity(operation.identity.status)"></p-tag></td>
        <td>{{ operation.attemptCount }}</td>
        <td>{{ operation.nextAttemptAtUtc ? (operation.nextAttemptAtUtc | date:'medium') : '—' }}</td>
        <td><button pButton type="button" label="Retry" icon="pi pi-replay" class="p-button-sm p-button-outlined"
          [disabled]="!canRetry(operation)" (click)="openRetry(operation)"
          [attr.aria-label]="'Retry deletion operation for ' + operation.userId"
          [pTooltip]="operation.status === 'action-required'
            ? 'Resolve the required ownership change before retrying'
            : 'Retry only the failed cleanup steps'"></button></td>
      </tr>
      <tr><td colspan="8" class="operation-context"><strong>Requested by {{ operation.actorId }}:</strong> {{ operation.reason }}</td></tr>
      <tr *ngIf="operation.lastError"><td colspan="8" class="operation-error">{{ operation.lastError }}</td></tr>
    </ng-template>
    <ng-template pTemplate="emptymessage"><tr><td colspan="8">No deletion operations match these filters.</td></tr></ng-template>
  </p-table>
</section>

<p-dialog header="Retry deletion operation" [(visible)]="showRetryDialog" [modal]="true"
  [closable]="!retrying" [style]="{ width: '34rem' }" (onHide)="closeRetry()">
  <p>Only failed cleanup steps will run again for <strong>{{ selectedOperation?.userId }}</strong>.</p>
  <label for="retryReason">Support reason</label>
  <textarea id="retryReason" pInputText rows="4" [formControl]="retryReason"
    placeholder="Explain why this operation is being retried"></textarea>
  <small *ngIf="retryReason.touched && retryReason.invalid" class="p-error">Enter 3–500 characters.</small>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text" [disabled]="retrying" (click)="closeRetry()"></button>
    <button pButton type="button" label="Retry failed steps" icon="pi pi-replay" [loading]="retrying"
      [disabled]="retryReason.invalid" (click)="submitRetry()"></button>
  </ng-template>
</p-dialog>
